// acceleration.js
import React, { useState } from "react";
import SharedHelmet from ".././Helmet";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Kalkulator Percepatan - Cara Menghitung Percepatan";
const DESCRIPTION =
  "Kalkulator percepatan menghitung percepatan berdasarkan perubahan kecepatan dan waktu.";
const KEYWORDS =
  "menghitung percepatan, kalkulator percepatan, menghitung percepatan berdasarkan perubahan kecepatan dan waktu";
const OG_URL = "https://do-calculate.com/calculator/id/acceleration";
function AccelerationCalculator() {
  const [initialVelocity, setInitialVelocity] = useState("");
  const [finalVelocity, setFinalVelocity] = useState("");
  const [time, setTime] = useState("");
  const [acceleration, setAcceleration] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!initialVelocity || !finalVelocity || !time) {
      setError(
        "Harap masukkan kecepatan awal, kecepatan akhir, dan waktu dengan benar"
      );
      setAcceleration("");
      return;
    }
    const initialVelocityValue = parseFloat(initialVelocity);
    const finalVelocityValue = parseFloat(finalVelocity);
    const timeValue = parseFloat(time);
    if (
      isNaN(initialVelocityValue) ||
      isNaN(finalVelocityValue) ||
      isNaN(timeValue)
    ) {
      setError(
        "Harap masukkan nilai yang valid untuk kecepatan awal, kecepatan akhir, dan waktu"
      );
      setAcceleration("");
      return;
    }
    const deltaVelocity = finalVelocityValue - initialVelocityValue;
    const deltaT = timeValue;
    const accelerationValue = deltaVelocity / deltaT;
    setAcceleration(accelerationValue.toFixed(2));
    setError("");
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Selamat datang! Percepatan dapat dinyatakan secara matematis dengan dua rumus utama
                  tergantung pada data yang diberikan dalam soal. Dalam kasus ini, kita menggunakan rumus berikut:
                </p>
                <p>Percepatan = Perubahan kecepatan / Perubahan waktu</p>
                <p>a = Δv / Δt</p>
                <p>Dimana:</p>
                <ul>
                  <li>a: percepatan, diukur dalam satuan m/s².</li>
                  <li>
                    Δv: perubahan kecepatan (kecepatan akhir - kecepatan awal) diukur dalam satuan m/s.
                  </li>
                  <li>
                    Δt: perubahan waktu (waktu akhir - waktu awal) diukur dalam satuan s.
                  </li>
                </ul>
                <p>
                  Untuk menghitung percepatan, masukkan nilai yang diperlukan dan klik "Hitung Percepatan" untuk mendapatkan hasil.
                </p>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div >
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Kecepatan Awal (m/s)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="0"
                        value={initialVelocity}
                        onChange={(e) => setInitialVelocity(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Kecepatan Akhir (m/s)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="60"
                        value={finalVelocity}
                        onChange={(e) => setFinalVelocity(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Waktu (detik)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="4"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Hitung Percepatan
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Kesalahan: {error}
                      </p>
                    ) : (
                      <>
                        {acceleration !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              Percepatan (m/s²): {acceleration}
                            </p>
                            <p className="p-3 mb-2 bg-info text-black">
                              Langkah-langkah penyelesaian: <br />- Tuliskan rumus: percepatan =
                              perubahan kecepatan / perubahan waktu - Substitusikan data dan hitung hasilnya.
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <RelatedLinks />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
}
export default AccelerationCalculator;